import { render, staticRenderFns } from "./OrderType.vue?vue&type=template&id=a7e4b114&"
import script from "./OrderType.vue?vue&type=script&lang=js&"
export * from "./OrderType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7e4b114')) {
      api.createRecord('a7e4b114', component.options)
    } else {
      api.reload('a7e4b114', component.options)
    }
    module.hot.accept("./OrderType.vue?vue&type=template&id=a7e4b114&", function () {
      api.rerender('a7e4b114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/steps/OrderType.vue"
export default component.exports